// extracted by mini-css-extract-plugin
export var base = "Footer-module--base--82cf5";
export var columnCenter = "Footer-module--column-center--5f446";
export var columnLeft = "Footer-module--column-left--2ff5c";
export var columnRight = "Footer-module--column-right--37a33";
export var innerContainer = "Footer-module--inner-container--4ba0b";